import React, { useRef, useEffect, useCallback, useState} from 'react';
import Documented from "components/help/Documented.js"
import {AUDITION_BUTTON} from 'constants/contextual-help.js';
import {useScrollTo} from "components/selector2/useScrollTo.js";
import {trim} from "utils/trim.js"
import {setSourceExploring} from 'actions/index.js';
import Colors from 'components/Colors.js';
import TagsInfo from "components/installation/TagsInfo.js";
import {SOUND_RATED} from 'decentralized/xanadu/LinkTypes.js';
import ContentDropdown from "components/dropdowns/ContentDropdown.js";
import FavoriteButton from "components/FavoriteButton.js";
import ethereum from "decentralized/ethereum.js";
import {
    setQuickAddSearchText,
    setSampleDragging} from 'actions/index.js';
import Sample from "repos/Sample.js";
import {connect} from 'react-redux';

const colors = new Colors();

let MAX_SIZE = 100;
let SAMPLE_CACHE = {};

const SampleStreamOption = ({
    onClickTag,
    id,
    loadingSample,
    scrollRef,
    selected,
    track,
    topOffset,
    isExploringThis,
    isExploringSomething,
    sample,
    setSourceExploring,
    tags=[],
    samples,
    setSampleDragging,
    setSearchText,
}) => { 
    let ref = useRef(undefined);
    let [dropdownPos, setDropdownPos] = useState(undefined);
    let [isTagging, setIsTagging] = useState(false);
    let [loading, setLoading] = useState(false);
    if (!samples) {
        useScrollTo({scrollRef, ref, isCurrent: selected, topOffset: 200, mouseDown: loadingSample});
    }

    const audition = useCallback(async (e) => {
        if (e.metaKey) {
            setSourceExploring(sample);
        }
        if (selected) { return; }
        loadingSample.current = true;
        setLoading(true);
        if (samples) {
            await sample.fetchAudio();
            await track.useNewSound(sample, true);
        } else {
            let _c = track.samplesStream.sounds.indexOf(id);
            await track.auditionSeek(_c - 2);
        }
        setLoading(false);
        loadingSample.current = false;
    }, [samples, track, setLoading, sample, id, selected]);

    useEffect(() => {
        if (!samples && selected && isExploringSomething) {
            setSourceExploring(sample);
        }
    }, [isExploringSomething, selected, samples]);

    const createNewTrack = useCallback(() => {
        let samplesStream = track.samplesStream.getCopy(sample);
        track.sequencerEngine.addSound(sample, undefined, undefined, undefined, undefined, samplesStream);
        setDropdownPos(undefined);
    }, [sample, setDropdownPos]);

    const _onClickTag = useCallback(async (e, tag) => {
        e.stopPropagation();
        loadingSample.current = true;
        await onClickTag(tag, e.metaKey);
        loadingSample.current = false;
    }, [setLoading, onClickTag]);

    const onContextMenu = useCallback((e) => {
        e.stopPropagation();
        let x = e.clientX - ref.current.getBoundingClientRect().left;
        let y = e.clientY - scrollRef.current.getBoundingClientRect().top;
        if (x > 200) {
            x -= 200;
        }
        x = Math.max(0, x);
        if (topOffset) {
            y += topOffset;
        }
        setDropdownPos({x,y});
        e.preventDefault();
    }, [setDropdownPos]);


    if (!sample) {
        return [];
    }
    let className = "sample-stream-option";
    if (selected) {
        className += " selected";
    }
    if (loading) {
        className += " flashit";
    }
    let _tags = sample.tags.filter(x => !tags.includes(x));
    if (dropdownPos) {
        className += " showing-dropdown";
    }

    if (isExploringThis) {
        className += " is-exploring";
    }
    _tags.sort();
    return (
        <div
          onContextMenu={onContextMenu}
          ref={ref}
        >
        <Documented
          element={AUDITION_BUTTON}
          draggable={true}
          onDragOver={(e) => e.preventDefault()}
          onDragStart={() => setSampleDragging(sample)}
          onClick={audition}
          id={samples ? undefined : "sample-option-" + sample.getId()}
          className={className}>
              <ContentDropdown
                createNewTrack={createNewTrack}
                setIsTagging={setIsTagging}
                dropdownPos={dropdownPos}
                setDropdownPos={setDropdownPos}
                type={SOUND_RATED}
                content={sample}
                setPackToSearch={() => []}
                contentHash={sample.getId()}/>
              {sample.getThumbnail() ?
               <img
                 src={sample.getThumbnail()} className="s-thumb"/> : ''}
              {sample.favorited ? <div className="heart favorited"/> : ''}
          <div className="s-name">{truncate(trim(sample.name))}</div>
          {sample.packs && sample.packs.map(pack => <div style={{backgroundColor: colors.getColorForHash(pack)}}className="pack-thumb"/>)}
          <div className="s-tags">
            {_tags.map(x => <div
                              onClick={(e) => _onClickTag(e, x)}
                              className="s-tag">{x}</div>)}
          </div>
        </Documented>
          {isTagging ? <TagsInfo  onTag={() => setIsTagging(false)} content={sample}/> : ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      isExploringThis : props.sample === state.selector.sourceExploring,
      isExploringSomething: state.selector.sourceExploring !== undefined,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSampleDragging: (s) => dispatch(setSampleDragging(s)),
      setSearchText: x => dispatch(setQuickAddSearchText(x)),
      setSourceExploring: x => dispatch(setSourceExploring(x)),
  };
};

const MAX_NAME_LENGTH = 24;
const truncate = (name) => {
    if (name.length < MAX_NAME_LENGTH) {
        return name;
    }
    return name.slice(0, MAX_NAME_LENGTH) + '...';
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleStreamOption);
